import axios from "axios";
import { API_URL, authHeader } from "./api";

const ENDPOINT_URL = API_URL + "booking/";

class GuestService {
  getBookings(filter = "", params = {}) {
    return axios.get(ENDPOINT_URL + "list/" + filter, {
      headers: authHeader(),
      params,
    });
  }

  getBooking(bookingId, params = {}) {
    return axios.get(ENDPOINT_URL + bookingId, { headers: authHeader(), params });
  }

  addGuest(guest) {
    return axios.post(ENDPOINT_URL, guest, { headers: authHeader() });
  }

  updateBooking(booking) {
    return axios.patch(ENDPOINT_URL, booking, { headers: authHeader() });
  }

  deleteBooking(bookingId) {
    return axios.delete(ENDPOINT_URL + bookingId, { headers: authHeader() });
  }

  checkout(bookingId) {
    return axios.get(ENDPOINT_URL + bookingId + "/checkout", {
      headers: authHeader(),
    });
  }

  //accessDoorIds = [<string>, <string>, ...]
  sendKeys(
    bookingId,
    roomNumber,
    accessDoorIds,
    checkinDate,
    checkoutDate,
    from,
    validNow,
  ) {
    let request = {
      roomNumber,
      doors: accessDoorIds,
      checkinDate,
      checkoutDate,
      from,
      validNow,
    };
    return axios.post(ENDPOINT_URL + bookingId + "/sendKeys", request, {
      headers: authHeader(),
    });
  }

  updateFutureBookings() {
    return axios.get(ENDPOINT_URL + "updatefutures", { headers: authHeader() });
  }

  getPdfURL(bookingId) {
    return ENDPOINT_URL + bookingId + "/pdf";
  }

  sendInvitation(bookingId) {
    return axios.get(ENDPOINT_URL + bookingId + "/sendInvite", {
      headers: authHeader(),
    });
  }

  checkKeyUsed(bookingId) {
    return axios.post(
      ENDPOINT_URL + bookingId + "/check-key-used",
      {},
      { headers: authHeader() },
    );
  }
}

export default new GuestService();
